export default function initSupervisorSearch() {
	const supervisorSearch = document.querySelector('.supervisor-search');
	if (supervisorSearch && supervisorAutocomplete) {
		const searchAutocomplete = supervisorSearch.querySelector('.search-autocomplete');
		const resultsSupervisors = supervisorSearch.querySelector('.search-results-supervisors');
		const resultsExpertise = supervisorSearch.querySelector('.search-results-expertise');
		const resultsKeywords = supervisorSearch.querySelector('.search-results-keywords');

		const resultDom = document.querySelector('.search-results');
		const resultInnerDom = resultDom.querySelector('.results');
		const tagsWrapper = supervisorSearch.querySelector('.tags');
		const input = supervisorSearch.querySelector('input');

		const localDataRaw = window.localStorage.getItem('supervisor-search');
		const localData = localDataRaw ? JSON.parse(localDataRaw) : {supervisors:[],expertise:[],keywords:[]};

		const selectedSupervisors = new Map();
		const selectedExpertise = new Map();
		const selectedKeywords = new Map();

		if (selectedValues && ((selectedValues.supervisors && selectedValues.supervisors.length > 0) || (selectedValues.expertise && selectedValues.expertise.length > 0) || (selectedValues.keywords && selectedValues.keywords.length > 0))) {
			selectedValues.supervisors.forEach(value => {
				addTag('supervisor', value, selectedSupervisors, false);
			});
			selectedValues.expertise.forEach(value => {
				addTag('expertise', value, selectedExpertise, false);
			});
			selectedValues.keywords.forEach(value => {
				addTag('keyword', value, selectedKeywords, false);
			});
		}
		else {
			localData.supervisors.forEach(value => {
				addTag('supervisor', value, selectedSupervisors, false);
			});
			localData.expertise.forEach(value => {
				addTag('expertise', value, selectedExpertise, false);
			});
			localData.keywords.forEach(value => {
				addTag('keyword', value, selectedKeywords, false);
			});
		}
		searchSupervisors(false);

		let collapseClicked = false;

		input.addEventListener('focusout', () => {
			setTimeout(() => {
				if (collapseClicked) {
					input.focus();
					collapseClicked = false;
				}
				else {
					searchAutocomplete.classList.remove('show');
				}
			}, 200);
		});

		input.addEventListener('input', () => {
			autocomplete();
		});

		input.addEventListener('focusin', () => {
			if (!collapseClicked) {
				autocomplete();
			}
		});

		resultsExpertise.querySelectorAll('.expertise-category .result.main').forEach(result => {
			const expertise = JSON.parse(result.dataset.expertise);
			result.addEventListener('click', e => {
				console.log(e, e.srcElement.classList.contains('collapse-btn') || e.srcElement.parentElement.classList.contains('collapse-btn'));
				if (!e.srcElement.classList.contains('collapse-btn') && !e.srcElement.parentElement.classList.contains('collapse-btn')) {
					addTag('expertise', expertise, selectedExpertise);
				}
			});

			const collapseBtn = result.querySelector('.collapse-btn');
			const parent = result.parentElement;
			collapseBtn.addEventListener('click', () => {
				collapseClicked = true;
				const value = input.value.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
				result.classList.toggle('collapsed');

				parent.querySelectorAll('.result.child').forEach(el => {
					el.remove();
				});
				if (!result.classList.contains('collapsed')) {
					expertiseAutocomplete.forEach(expertise => {
						if (expertise.parent !== parseInt(parent.dataset.id) || (value.trim().length > 0 && expertise.name.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").search(value) === -1)) {
							return;
						}
						addExpertise(expertise, parent);
					});
				}
			});
		});

		function autocomplete() {
			const value = input.value.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

			searchAutocomplete.classList.add('show');

			resultsSupervisors.innerHTML = ``;
			resultsKeywords.innerHTML = ``;
			resultsSupervisors.classList.remove('show');
			resultsKeywords.classList.remove('show');

			resultsExpertise.querySelectorAll('.expertise-category').forEach(category => {
				category.classList.remove('show');
			});
			resultsExpertise.querySelectorAll('.expertise-category .result.child').forEach(result => {
				result.remove();
			});

			if (value.length > 1) {
				supervisorAutocomplete.forEach(supervisor => {
					if (supervisor.name.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").search(value) === -1) {
						return;
					}
					const supervisorElem = document.createElement('div');
					supervisorElem.classList.add('result');
					supervisorElem.innerHTML = `<img src="${supervisor.image}" alt="${supervisor.name}" class="result-image"><span class="result-name">${supervisor.name}</span>`;
					resultsSupervisors.classList.add('show');
					resultsSupervisors.append(supervisorElem);

					supervisorElem.addEventListener('click', () => {
						addTag('supervisor', supervisor, selectedSupervisors);
					});
				});

				keywordsAutocomplete.forEach(keyword => {
					if (keyword.name.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").search(value) === -1) {
						return;
					}
					const keywordElem = document.createElement('div');
					keywordElem.classList.add('result');
					keywordElem.innerHTML = `<span class="result-name">${keyword.name}</span> <span class="result-count">[${keyword.count}]</span>`;
					resultsKeywords.classList.add('show');
					resultsKeywords.append(keywordElem);

					keywordElem.addEventListener('click', () => {
						addTag('keyword', keyword, selectedKeywords);
					});
				})
			}

			expertiseAutocomplete.forEach(expertise => {
				if ((value.length === 0 && expertise.parent !== 0) || (value.length > 0 && expertise.name.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").search(value) === -1)) {
					return;
				}
				const parent = resultsExpertise.querySelector(`.expertise-category[data-id="${expertise.parent === 0 ? expertise.id : expertise.parent}"]`);
				addExpertise(expertise, parent);
			});
		}

		function addExpertise(expertise, parent) {
			parent.classList.add('show');
			if (expertise.parent === 0) {
				return;
			}
			parent.querySelector('.result.main').classList.remove('collapsed');
			const expertiseElem = document.createElement('div');
			expertiseElem.classList.add('result', 'child');
			expertiseElem.innerHTML = `<span class="result-name">${expertise.name}</span> <span class="result-count">[${expertise.count}]</span>`;
			resultsExpertise.classList.add('show');
			parent.appendChild(expertiseElem);

			expertiseElem.addEventListener('click', e => {
				console.log(e);
				addTag('expertise', expertise, selectedExpertise);
			});
		}

		function addTag(type, data, map, update = true) {
			input.value = '';
			searchAutocomplete.classList.remove('show');
			if (map.has(data.id)) {
				return;
			}
			const tag = document.createElement('div');
			tag.classList.add('tag');
			tag.dataset.type = type;
			tag.dataset.id = data.id;
			tag.innerHTML = (data.label ? data.label : data.name) + `<svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.18028 9.31969L6.49998 6.99997L8.81969 9.31969L9.31969 8.81969L6.99997 6.49998L9.31969 4.18028L8.81969 3.68028L6.49998 6L4.18028 3.68028L3.68028 4.18028L6 6.49998L3.68028 8.81969L4.18028 9.31969ZM6.50103 12.4375C5.68623 12.4375 4.91854 12.2816 4.19795 11.97C3.47737 11.6583 2.84722 11.2327 2.3075 10.6933C1.76777 10.1538 1.34201 9.52389 1.0302 8.80363C0.718401 8.08336 0.5625 7.31582 0.5625 6.50103C0.5625 5.67982 0.718333 4.90793 1.03 4.18534C1.34167 3.46275 1.76724 2.8342 2.30672 2.29969C2.84621 1.76517 3.47608 1.34201 4.19634 1.0302C4.91661 0.718401 5.68415 0.5625 6.49894 0.5625C7.32015 0.5625 8.09204 0.718333 8.81463 1.03C9.53722 1.34167 10.1658 1.76464 10.7003 2.29891C11.2348 2.83319 11.658 3.46146 11.9698 4.18373C12.2816 4.906 12.4375 5.67773 12.4375 6.49894C12.4375 7.31374 12.2816 8.08143 11.97 8.80202C11.6583 9.5226 11.2353 10.1528 10.7011 10.6925C10.1668 11.2322 9.53851 11.658 8.81624 11.9698C8.09398 12.2816 7.32224 12.4375 6.50103 12.4375Z" fill="#00569B"/></svg>`;
			tagsWrapper.append(tag);
			map.set(data.id, {data, tag});
			if (update) {
				updateSelected();
				searchSupervisors();
			}
			tag.addEventListener('click', () => {
				tag.remove();
				map.delete(data.id);
				updateSelected();
				searchSupervisors();
			});
		}

		const searchBtn = supervisorSearch.querySelector('.searchBtn');
		if (searchBtn) {
			searchBtn.addEventListener('click', searchSupervisors);
		}

		function updateSelected() {
			const data = {
				supervisors: [],
				expertise: [],
				keywords: [],
			};

			selectedSupervisors.forEach(value => {
				data.supervisors.push(value.data);
			});

			selectedExpertise.forEach(value => {
				data.expertise.push(value.data);
			});

			selectedKeywords.forEach(value => {
				data.keywords.push(value.data);
			});

			window.localStorage.setItem('supervisor-search', JSON.stringify(data));
		}

		function searchSupervisors(updateUrl = true) {
			const data = {
				action: 'supervisor_search',
				supervisors: Array.from(selectedSupervisors.keys()),
				expertise: Array.from(selectedExpertise.keys()),
				keywords: Array.from(selectedKeywords.keys()),
			};
			console.log(data);
			jQuery.post(
				fuav_params.ajaxurl,
				data,
				response => {
					resultInnerDom.innerHTML = response;
					if (updateUrl) {
						changeUrl();
					}
				}
			);
		}

		async function changeUrl() {
			const params = new URLSearchParams;

			selectedSupervisors.forEach(value => {
				console.log(value);
				params.append('supervisor[]', value.data.label);
			});

			selectedExpertise.forEach(value => {
				console.log(value);
				params.append('expertise[]', value.data.name + "-" + value.data.id);
			});

			selectedKeywords.forEach(value => {
				console.log(value);
				params.append('keyword[]', value.data.name);
			});

			console.log(params);

			window.history.replaceState({}, '', '?' + params.toString());
		}
	}
}
